(function () {
  const SECTION_SELECTOR = '#shopify-section-wishlist-products'; 
  const BUTTON_SELECTOR = '.st-atc-button';
  const LINK_SELECTOR = '.st-content a';
  const NEW_LABEL = 'View product'; 

  function replaceButtonText(btn, label) {
    const inner = btn.querySelector('.btn__text, .button__text, .st-atc-button__text');
    if (inner) {
      inner.textContent = label;
    } else {
      let touched = false;
      btn.childNodes.forEach(n => {
        if (n.nodeType === Node.TEXT_NODE) {
          n.nodeValue = ' ' + label;
          touched = true;
        }
      });
      if (!touched) btn.textContent = label;
    }
    btn.setAttribute('aria-label', label);
    btn.title = label;
  }

  function swapAll(root = document) {
    root.querySelectorAll(BUTTON_SELECTOR).forEach(btn => {
      if ((btn.textContent || '').trim().toLowerCase() === 'more details') {
        replaceButtonText(btn, NEW_LABEL);
      }
    });
    root.querySelectorAll(LINK_SELECTOR).forEach(a => {
      if ((a.textContent || '').trim().toLowerCase() === 'login') {
        a.textContent = 'Log In Here';
              }
    });
  }

  function init() {
    const scope = document.querySelector(SECTION_SELECTOR) || document.body;
    swapAll(scope);

    const mo = new MutationObserver(() => swapAll(scope));
    mo.observe(scope, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', e => {
      if (!SECTION_SELECTOR || e.target.matches(SECTION_SELECTOR)) swapAll(e.target);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
